import dayUrl from '../assets/audio/sfx/countryside_ambiance.mp3';
import nightUrl from '../assets/audio/sfx/night_ambiance.mp3';
import rainUrl from '../assets/audio/sfx/rain_ambiance.mp3';
import { conditions } from '../rendering/environment/conditions.js';
import { AmbientBed } from './ambient-bed.js';
import { mixer } from './audio-mixer.js';

/** Each bed plays at the matched loudness (`audio-engine.ts`), so the quiet night recording sits level with the day; this sets all three under the world. */
const STRENGTH = .09, FADE_MS = 2500, TICK_MS = 100;
const smooth = (value: number, from: number, to: number) => { const t = Math.min(1, Math.max(0, (value - from) / (to - from))); return t * t * (3 - 2 * t); };

/**
 * The beds under everything, which start as soon as the browser allows sound and loop for the whole visit, in the lobby and in
 * the world: the countryside by day, a night bed after dusk, and rain when it rains, each crossfading with the shared conditions
 * (`conditions.ts`). They are gapless loops on the effects bus, so they follow the effects volume and the mute switch.
 */
export class Ambience {
  private readonly day = new AmbientBed(mixer.engine, dayUrl, STRENGTH);
  // The night recording fades in and out over its first and last eighth of a second (plus the decoder's padding); the loop skips both so it never dips.
  private readonly night = new AmbientBed(mixer.engine, nightUrl, STRENGTH, { head: .17, tail: .15 });
  private readonly rain = new AmbientBed(mixer.engine, rainUrl, STRENGTH);
  private readonly started = performance.now();

  constructor() { setInterval(() => this.tick(), TICK_MS); }

  private tick() {
    const fade = Math.min(1, (performance.now() - this.started) / FADE_MS), master = mixer.sfxGain > 0 ? fade : 0, { night, rain } = conditions;
    const wet = smooth(rain, .05, .6);
    // The countryside gives way to night, and both are drowned out by rain; rain is a bed of its own.
    this.day.update((1 - night) * (1 - .85 * wet), master, TICK_MS / 1000);
    this.night.update(night * (1 - .7 * wet), master, TICK_MS / 1000);
    this.rain.update(wet, master, TICK_MS / 1000);
  }
}
